import React, { useState } from "react";
import { Box, Paper, Typography } from "@mui/material";
import Sidebar from "./AdminPanel/Sidebar";
import TopBar from "./AdminPanel/TopBar";
import { useDashboardTheme } from "../../context/DashboardThemeContext";

export default function AdminPanel() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const { dashboardTheme } = useDashboardTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: dashboardTheme.dashboard_background,
        display: "flex",
        color: dashboardTheme.text_color,
        overflowX: "hidden",
      }}
    >
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TopBar
          sidebarOpen={sidebarOpen}
          onToggleSidebar={() => setSidebarOpen((prev) => !prev)}
        />

        <Box
          component="main"
          sx={{
            flex: 1,
            p: { xs: 2, md: 3 },
          }}
        >
          <Paper
            elevation={0}
            sx={{
              borderRadius: "24px",
              border: `1px solid ${dashboardTheme.border_color}`,
              bgcolor: dashboardTheme.card_background,
              p: { xs: 2.5, md: 3 },
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: 24, md: 32 },
                fontWeight: 600,
                color: dashboardTheme.text_color,
                lineHeight: 1.2,
              }}
            >
              Bienvenidos
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
}